module.exports = __webpack_public_path__ + "img/矢量智能对象1.a9b5ebbb.png";